import React, { Suspense, Component, Fragment } from "react";
import ReactDOM from "react-dom";
import { connect, Provider } from "react-redux";
import store from "./redux/store";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import * as Sentry from "@sentry/react";
import moment from "moment";
import Avtar from "./MsgBubbleComponent/Avtar";
import { changeLevel, change_Integration_Channel } from "./redux/actions";
if (
  window.location.hostname.includes("localhost") ||
  window.location.hostname.includes("devtest")
) {
  //  console.log = () => {};
  // console.warn = () => {};
  // console.error = () => {};
} else {
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
}
const chuckExperssion = new RegExp(/^Loading CSS chunk$/);
const notFoundExpression = new RegExp(/^Object Not Found Matching$/);
Sentry.init({
  dsn: "https://50b49df978b4b68df6336164f5df5bfc@o880208.ingest.sentry.io/4506575621849088",
  ignoreErrors: [
    "TypeError: Failed to fetch",
    "TypeError: NetworkError when attempting to fetch resource.",
    "TypeError: cancelled",
    "TypeError: Load failed",
    "/Object Not Found Matching\b/",
    "AxiosError: Network Error",
    "AxiosError: Request aborted",
    "/Loading CSS chunk\b/",
    "Non-Error promise rejection captured",
    chuckExperssion,
    notFoundExpression,
  ],
  beforeSend(event, hint) {
    // const error = hint.originalException;
    // if (
    //   error &&
    //   error.message &&
    //   (error.message.match(chuckExperssion) ||
    //     error.message.match(notFoundExpression) ||
    //     error.message.match(/Object Not Found Matching/i) ||
    //     error.message.match(/Loading CSS chunk/i))
    // ) {
    //   return null;
    // }
    // return event;
    if (
      event !== undefined &&
      event.exception !== undefined &&
      event.exception.values !== undefined &&
      event.exception.values.length === 1
    ) {
      var e = event.exception.values[0];
      if (
        (e.type === "UnhandledRejection" &&
          e.value === "Non-Error promise rejection captured with value: ") ||
        event.exception.values.filter(
          (f) =>
            f.type.match(chuckExperssion) || f.value.match(chuckExperssion),
        ).length > 0 ||
        event.exception.values.filter(
          (f) =>
            f.type.match(notFoundExpression) ||
            f.value.match(notFoundExpression),
        ).length > 0
      ) {
        return null;
      }
    }
  },
  integrations: [
    new Sentry.Replay({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 0.0, //  Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const MsgApp = React.lazy(() => import("./MsgApp"));

function decodeURL() {
  if (!window.location.href.split("?")[1]) {
    console.log("No data passed in to Chat element :(.");
    return;
  }
  var params = window.location.href.split("?")[1].split("&");
  var data = {};
  for (var x in params) {
    data[params[x].split("=")[0]] = decodeURIComponent(params[x].split("=")[1]);
  }
  return data;
}
function loadGA4Script(measurementId) {
  if (!measurementId) return;

  if (window.bmbGAInitialized === measurementId) {
    return;
  }

  window.bmbGAInitialized = measurementId;

  window.dataLayer = window.dataLayer || [];

  function gtag() {
    window.dataLayer.push(arguments);
  }

  window.gtag = gtag;
  gtag("js", new Date());

  const existingScript = document.getElementById("bmb-ga4-script");

  if (!existingScript) {
    const script = document.createElement("script");

    script.id = "bmb-ga4-script";

    script.async = true;

    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;

    script.onload = () => {
      gtag("config", measurementId, {
        send_page_view: false,
        debug_mode: true,
        cookie_flags: "SameSite=None;Secure",
        allow_google_signals: false,
        send_scrolls: false,
      });
      // gtag("event", "page_view", {
      //   page_title: document.title,
      //   page_location: window.location.href,
      //   page_path: window.location.pathname,
      // });

      console.log("GA4 Loaded:", measurementId);
    };

    document.head.appendChild(script);
  }
}

function fireGAEvent(eventName, params = {}) {
  try {
    if (
      typeof window.gtag === "function" &&
      typeof eventName === "string" &&
      eventName.trim() !== ""
    ) {
      window.gtag("event", eventName, params);
      console.log("GA event fired:", eventName, params);
      return true;
    }

    console.warn("gtag unavailable:", eventName);
    return false;
  } catch (error) {
    console.error("GA event fire failed:", eventName, error);
    return false;
  }
}

function normalizeGABridgePayload(data) {
  if (!data) return null;

  if (typeof data === "object") {
    return data;
  }

  if (typeof data === "string" && data.trim().startsWith("{")) {
    try {
      return JSON.parse(data);
    } catch (error) {
      return null;
    }
  }

  return null;
}

function handleGABridgeMessage(event) {
  const payload = normalizeGABridgePayload(event?.data);

  if (!payload || payload.type !== "BMB_GA_EVENT") {
    return;
  }

  console.log("GA message received:", payload);
  fireGAEvent(payload.eventName, payload.params || {});
}

function setupGABridgeListener() {
  if (window.__bmbGALoggerAttached) {
    return;
  }

  window.__bmbGALoggerAttached = true;
  window.addEventListener("message", handleGABridgeMessage, false);
}

setupGABridgeListener();

const debugInputPreChatGids = new Set([
  "5d46a893-e321-4f85-a8bd-b30400535985",
  "ca6f18bc-c995-467e-8d88-b2bf01284b9e",
]);

const appInsights = new ApplicationInsights({
  config: {
    connectionString: process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING,
    enableAutoRouteTracking: false,
  },
});

appInsights.loadAppInsights();

function isDebugGid(gid) {
  return !!gid && debugInputPreChatGids.has(gid);
}

function trackAzureDebugTrace(message, properties) {
  try {
    appInsights.trackTrace(
      {
        message,
        severityLevel: 1,
      },
      properties,
    );
  } catch (error) {
    console.error("Failed to log trace to Azure:", error);
    Sentry.captureException(error);
  }
}

function getQueryValue(key) {
  const queryString = window.location.search || "";
  const params = new URLSearchParams(queryString);
  return params.get(key) || "";
}

function logInputPreChatToAzure(gid, inputPreChatValue) {
  if (!isDebugGid(gid)) {
    return;
  }
  console.log("Logging inputPreChat to Azure:", { gid, inputPreChatValue });
  const traceProperties = {
    gid,
    inputPreChat: inputPreChatValue,
    host: window.location.host,
    href: window.location.href,
    timestamp: new Date().toISOString(),
  };

  trackAzureDebugTrace("Index Debug inputPreChat", traceProperties);
}

var parent_location,
  parent_title,
  gid,
  iid,
  pid,
  mobile,
  parent_referrer,
  defaultOpen,
  position,
  customStyle,
  previewMode,
  token,
  botData,
  buttonscript,
  inputprechat,
  fallbackMessage;

const gidBeforeDecode = getQueryValue("gid");
if (isDebugGid(gidBeforeDecode)) {
  trackAzureDebugTrace("IndexDebug pre-decode context", {
    gid: gidBeforeDecode,
    host: window.location.host,
    href: window.location.href,
    timestamp: new Date().toISOString(),
  });
}

var data = decodeURL();
if (data) {
  parent_referrer = data.referrer;
  parent_location = data.location;
  parent_title = data.title;
  gid = data.gid;
  pid = data.pid;
  token = data.token;
  iid = data.iid;
  mobile = data.mobile;
  defaultOpen =
    data.open === undefined ? false : data.open === "0" ? false : true;
  previewMode = data.preview ? data.preview : false;
  position = data.position === "left" ? "chat_area_left" : "chat_area";
  customStyle = data.custom ? "custom" : "";
  buttonscript = data.buttonscript === undefined ? false : true;
  inputprechat = data.inputPreChat === undefined ? "" : data.inputPreChat;
  fallbackMessage =
    data.fallbackMessage === undefined ? "" : data.fallbackMessage;
}

const gidAfterDecode = gid || gidBeforeDecode;
if (isDebugGid(gidAfterDecode)) {
  trackAzureDebugTrace("Index Debug decoded URL data", {
    gid: gidAfterDecode,
    decodedUrlData: JSON.stringify(data || {}),
    timestamp: new Date().toISOString(),
  });
}

const query = window.location.search.slice(1);
const start = query.indexOf("inputPreChat=");
if (start >= 0) {
  inputprechat = decodeURIComponent(
    query.substring(start + "inputPreChat=".length),
  ).replace(/=$/, "");
}

console.log("inputprechat", inputprechat);

if (!gid || !iid) {
  gid = "73574010-2f33-4b41-8b8a-09d18b025a56";
  mobile = true;
  iid = "1ae35252-799c-41a0-b2a6-c086ccf68f25";
  defaultOpen = false;
  position = "chat_area";
  customStyle = "";
}

logInputPreChatToAzure(gid, inputprechat);

// Make sure frame is open when the bot is being interacted with (see chatplugin.js)
window.addEventListener("click", () => {
  window.postMessage("messengerwindowOpen");
});

class App extends Component {
  constructor(props) {
    super(props);
    {
    }
    this.state = {
      animation: {
        bubbleToFadeIn: true,
      },
      isLoading: true,
      opened:
        this.props.defaultOpen ||
        (mobile === "false" &&
          localStorage.getItem(iid + "-opened") === "open"),
      prechatData: null,
    };
    window.addEventListener("message", this.windowMessage.bind(this), false);
  }
  componentDidMount() {
    if (
      inputprechat !== undefined &&
      inputprechat !== null &&
      inputprechat !== ""
    ) {
      var params = inputprechat.trim().split(";");
      var data = {};
      for (var x in params) {
        if (params[x] !== "") {
          var text = params[x].split(":")[0].trim();
          var value = params[x].split(":")[1].trim();
          data[text] = value;
        }
      }
      this.setState({
        prechatData: data,
      });
    }
    var contentUrl = "https://assets.bookmebob.com";
    if (window.location.host.match("concierge.synxis.com"))
      contentUrl = "https://assets.concierge.synxis.com";
    if (
      window.location.host.includes("devtest") ||
      window.location.host.includes("localhost")
    ) {
      contentUrl = "https://botintegrationdemo.blob.core.windows.net";
    }
    fetch(`
      ${contentUrl}/messengerx/${iid}.json?ut=${Date.now()}`)
      .then((res) => res.json())
      .then((result) => {
        if (!gid || !iid) {
          gid = result.gid;
          iid = result.iid;
        }
        console.log(
          moment().format("YYYY-MM-DD hh:mm:ss"),
          "Json Loaded",
          result,
        );
        const ga4 = result?.botSettings?.gA4Tracking;

        if (ga4?.enabled && ga4?.measurementId) {
          loadGA4Script(ga4.measurementId);
        }
        this.props.change_Integration_Channel(result.channel);

        if (result.channel === "HelpCenter") {
          this.props.changeLevel("Property");
        } else {
          this.props.changeLevel("Group");
        }
        console.log(moment().format("YYYY-MM-DD hh:mm:ss"), "Json Loaded");
        if (
          result.disabled === false &&
          result.nudges !== undefined &&
          result.botSettings !== undefined
        )
          this.setState({ botData: result });

        this.setState({ isLoading: false });
      })
      .catch(() => {
        this.setState({ isLoading: false });
      });
  }

  windowMessage(event) {
    if (
      event !== undefined &&
      event.data !== undefined &&
      event.data === "openAvtar"
    ) {
      this.setState({ opened: false });
    }
  }

  openMessenger() {
    this.setState({ opened: true });
    window.postMessage("openChatWindow");
  }

  hintClosed() {
    this.setState({ currentNudge: undefined });
  }

  render() {
    return (
      <Fragment>
        {gid !== undefined && iid !== undefined && !this.state.isLoading && (
          <Fragment>
            <MsgApp
              parent_location={parent_location}
              parent_title={parent_title}
              parent_referrer={parent_referrer}
              gid={gid}
              iid={iid}
              pid={pid}
              token={token}
              mobile={mobile}
              botData={this.state.botData}
              defaultOpen={defaultOpen}
              buttonscript={buttonscript}
              position={position}
              customStyle={customStyle}
              previewMode={previewMode}
              prechatData={this.state.prechatData}
              fallbackMessage={fallbackMessage}
              inputprechat={inputprechat}
            ></MsgApp>
            {/* {(!this.state.opened && this.state.botData !== undefined) && (
              <Suspense fallback={<div></div>}>
                <Avtar
                  botSettings={this.state.botData?.botSettings}
                  fadeIn={this.state.animation.bubbleToFadeIn}
                  currentNudge={this.state.botData?.nudges}
                  mobile={mobile}
                  disabledChatbot={this.state.botData.disabled}
                  onOpened={this.openMessenger.bind(this)}
                  position={position}
                >
                </Avtar>
              </Suspense>
            )} */}
          </Fragment>
        )}
      </Fragment>
    );
  }
}
const ConnectedApp = connect(null, {
  changeLevel,
  change_Integration_Channel,
})(App);

ReactDOM.render(
  <Provider store={store}>
    <Suspense
      fallback={
        <div id="spinner" className="container">
          <div className="loading"></div>
        </div>
      }
    >
      <ConnectedApp />
    </Suspense>
  </Provider>,
  document.getElementById("root"),
);
